var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"mobile-topbar"},[_c('a',{staticClass:"logo",on:{"click":function($event){return _vm.goHome()}}},[_c('img',{attrs:{"src":_vm.staticUrl+'office/xzdzm/images/logo.png'}})]),_c('a',{staticClass:"mobile-topbar-a"},[_vm._v("登陆/注册会员")])]),_c('div',{staticClass:"mobile-main"},[_c('user-login')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }